import { create } from "zustand";

interface ActiveArticleState {
  activeView: string;
  version: number;
  setActiveArticleView: (key: string) => void;
}

export const useActiveArticleStore = create<ActiveArticleState>((set) => ({
  activeView: 'GIST',
  version: 0,
  setActiveArticleView: (key:string) =>
    set((state) => ({
      activeView: key,
      version: state.version + 1,
    })),
}));
